<template>
    <div class="main">
        <div class="container mx-auto px-6 xl:px-0 pb-10">
            <div class="text-left w-full lg:w-2/3 mx-auto mt-10 privacy-policy">
                <SimplePageBuilder :response="response"></SimplePageBuilder>
            </div>
        </div>
    </div>
</template>
<script>
import { SimplePageBuilder } from '@freddiesflowers/frontend-component-library';
import { getButterCmsPage } from '@/helpers/ButterCmsHelpers';

export default {
    name: 'PrivacyPolicy',
    components: {
        SimplePageBuilder,
    },
    data() {
        return {
            response: [],
        };
    },
    created() {
        getButterCmsPage('privacy-policy').then((res) => this.response = res);
    },
};
</script>

<style lang="scss">
.privacy-policy {
    .teaser--text {
        max-width: unset;

        .heading--medium {
            font-size: 30px;
            line-height: 35px;
            margin-top: 15px;
            text-align: left;
        }
    }

    ul {
        list-style-type: disc;
    }
}
</style>
